import { getApplicationSettings } from 'owa-application-settings';
import type { MailboxInfo } from 'owa-client-types';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isOfflinePeopleDataViaPDVEnabled } from './isOfflinePeopleDataViaPDVEnabled';

export const isServerFirstPersonResolutionEnabled = (mailboxInfo: MailboxInfo): boolean => {
    const { enableServerFirstPersonResolution, enabled } = getApplicationSettings('OnePersonView');
    return (
        enabled &&
        enableServerFirstPersonResolution &&
        isOfflinePeopleDataViaPDVEnabled(mailboxInfo) &&
        // Enabling this feature only for enterprise mailboxes as
        // "/peopleLookup" API is not supported for consumer mailboxes yet.
        // @todo - Undo this when "/peopleLookup" API is supported for consumer mailboxes
        // until the backend flight is rolled out to mailboxes of all user types.
        // Tracking bug - https://msfast.visualstudio.com/FAST%20Experiences/_workitems/edit/789959
        !isConsumer(
            undefined /* smtpAddress - This param has to be undefined for properly checking multi-accounts. */,
            mailboxInfo
        )
    );
};
